import { ThemeName } from '@/types/theme';

export default function getRequestBodyTheme(theme: ThemeName | undefined): string | undefined {
  return !theme || theme === ThemeName.BRANDLIVE_OLD ? undefined : theme;
}
